import React from "react";
import { Typography, Button, FormControl, FormLabel, Grid, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Radio, Box, RadioGroup, TextField } from "@mui/material";
import styles from '../../PreAuthForms/PreAuthForms/FormAuth.module.css';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useTranslation } from "react-i18next";
import { LineOfBusinessEnum } from "../../../constants/BusinessConstants";
import dayjs from "dayjs";

const NegativePressureWoundTherapy = ({ handleClose, preAuthFormData }) => {
    const { t } = useTranslation();

    return (
        preAuthFormData && (
            <Dialog
                fullWidth
                maxWidth="md"
                open={true}
                onClose={handleClose}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} className={styles.DialogTitle}>
                    {t("PreAuthForm.negativePressureWoundHead")}
                </DialogTitle>
                <DialogContent>
                    <Typography sx={{ margin: '10px 0px' }}>
                        <span className={styles.asterisk}>*</span> {t("PreAuthForm.requiredField")}
                    </Typography>
                    <Grid container>
                        <Grid xs={12} md={6} className={styles.spacingTop} sx={{ marginTop: '0px !important' }}>
                            <FormControl className={styles.spacingRemoveTop}>
                                <Typography sx={{ margin: '10px 0px' }} className={styles.labelText}>
                                    {t("PreAuthForm.branchCode")}<span className={styles.asterisk}>&nbsp;*</span>
                                </Typography>
                                <TextField
                                    margin="normal"
                                    fullWidth
                                    size="small"
                                    autoFocus
                                    variant="outlined"
                                    id="name"
                                    maxLength="3"
                                    type="text"
                                    value={preAuthFormData[0].BranchCode}
                                    sx={{
                                        marginTop: '5px', borderRadius: "8px", backgroundColor: 'var(--color-disableField)', '& .Mui-disabled': {
                                            '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important', width: "220px",
                                        },
                                    }}
                                    disabled={true}
                                    inputProps={{ style: { cursor: 'not-allowed' } }}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Grid container>
                        <Grid xs={12}>
                            <p className={styles.headingText}>
                                {t("PreAuthForm.npwtWoundVacCriteriaForAHospicePatient").replace('#patient', LineOfBusinessEnum.patientToMember.toLowerCase())}
                            </p>
                        </Grid>
                        <Grid >
                            <ul className={styles.spacedList}>
                                <li>{t("PreAuthForm.npwtFirstCriteria")}</li>
                                <li>{t("PreAuthForm.npwtSecondCriteria").replaceAll('#patient', LineOfBusinessEnum.patientToMember.toLowerCase())}</li>
                            </ul>
                        </Grid>
                    </Grid>

                    {preAuthFormData[0]?.IsPatientMeetCriteria !== "" && preAuthFormData[0]?.IsPatientMeetCriteria !== undefined && <Grid container>
                        <Grid xs={12} className={styles.spacingTop}>
                            <FormControl className={styles.spacingRemoveTop}>
                                <FormLabel className={styles.labelText} id="demo-row-radio-buttons-group-label">
                                    1. {t("PreAuthForm.isPatientMeetCriteria").replace('#patient', LineOfBusinessEnum.patientToMember.toLowerCase())} <span className={styles.asterisk}>*</span>
                                </FormLabel>
                                <RadioGroup
                                    className='paddingLeftFifteenpx'
                                    value={preAuthFormData[0].IsPatientMeetCriteria}
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group">
                                    <FormControlLabel value="true" control={<Radio />} label="Yes" disabled={true} sx={{ cursor: 'not-allowed' }} />
                                    <FormControlLabel value="false" control={<Radio />} label="No" disabled={true} sx={{ cursor: 'not-allowed' }} />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    </Grid>}

                    {preAuthFormData[0]?.IsBriefTransitionPlanned !== "" && preAuthFormData[0]?.IsBriefTransitionPlanned !== undefined && <Grid container sx={{ paddingLeft: '20px' }}>
                        <Grid xs={12} className={styles.spacingTop}>
                            <FormControl className={styles.spacingRemoveTop}>
                                <FormLabel className={styles.labelText} id="demo-row-radio-buttons-group-label">
                                    a. {t("PreAuthForm.briefTransitionPlanned")} <span className={styles.asterisk}>*</span>
                                </FormLabel>
                                <RadioGroup
                                    className='paddingLeftFifteenpx'
                                    value={preAuthFormData[0].IsBriefTransitionPlanned}
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                >
                                    <FormControlLabel value="true" control={<Radio />} label="Yes" disabled={true} sx={{ cursor: 'not-allowed' }} />
                                    <FormControlLabel value="false" control={<Radio />} label="No" disabled={true} sx={{ cursor: 'not-allowed' }} />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    </Grid>}

                    {preAuthFormData[0]?.PlannedTransitionDate &&<Grid container sx={{ paddingLeft: '37px' }}>
                        <Grid xs={12} className={`${styles.spacingTop} marginZero`}>
                            <div>
                                <Typography className={styles.labelText}>
                                    {t("PreAuthForm.plannedTransitionDate")}
                                </Typography>
                                <LocalizationProvider dateAdapter={AdapterDayjs} >
                                    <DatePicker slotProps={{ textField: { variant: 'outlined' } }} sx={{
                                        '& .MuiInputBase-input': {
                                            height: '10px',
                                        },
                                        marginTop: '5px',
                                        backgroundColor: 'var(--color-disableField)',
                                    }} disabled={true} name="PlannedTransitionDate" value={dayjs(preAuthFormData[0].PlannedTransitionDate)} />
                                </LocalizationProvider>
                            </div>
                        </Grid>
                    </Grid>}

                    {preAuthFormData[0]?.IsCopiousDrainage !== "" && preAuthFormData[0]?.IsCopiousDrainage !== undefined && <Grid container sx={{ paddingLeft: '20px' }}>
                        <Grid xs={12} className={styles.spacingTop}>
                            <FormControl className={styles.spacingRemoveTop}>
                                <FormLabel className={`${styles.labelText} displayFlex`} id="demo-row-radio-buttons-group-label">
                                    <div>b.&nbsp;</div>
                                    <div>{t("PreAuthForm.copiousDescriptionDrainage")}<span className={styles.asterisk}>&nbsp;*</span></div>
                                </FormLabel>
                                <RadioGroup
                                    className='paddingLeftFifteenpx'
                                    value={preAuthFormData[0].IsCopiousDrainage}
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                >
                                    <FormControlLabel value="true" control={<Radio />} label="Yes" disabled={true} sx={{ cursor: 'not-allowed' }} />
                                    <FormControlLabel value="false" control={<Radio />} label="No" disabled={true} sx={{ cursor: 'not-allowed' }} />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    </Grid>}

                    {preAuthFormData[0]?.CopiousDrainageHour && <Grid container sx={{ paddingLeft: '37px' }}>
                        <Grid xs={12} sm={6} md={6} className={`${styles.spacingTop} marginZero`}>
                            <Typography className={`${styles.labelText} displayFlex`}>
                                {t("PreAuthForm.howMuch24Hours")}<span className="asteriskSignColor">&nbsp;*</span>
                            </Typography>
                            <TextField
                                aria-label="CopiousDrainageHour text field"
                                value={preAuthFormData[0].CopiousDrainageHour}
                                fullWidth
                                minRows={2}
                                maxLength={500}
                                size="small"
                                sx={{ marginTop: '5px', backgroundColor: 'var(--color-disableField)' }}
                                disabled={true}
                                inputProps={{ style: { cursor: 'not-allowed' } }}
                            />
                        </Grid>
                    </Grid>}

                    <p className={styles.headingText} style={{marginBottom: '0px'}}>{t("PreAuthForm.nPWT/WoundVac")}</p>

                    {preAuthFormData[0]?.IsPatientNPWTWound !== "" && preAuthFormData[0]?.IsPatientNPWTWound !== undefined && <Grid container>
                        <Grid xs={12} className={styles.spacingTop}>
                            <FormControl className={styles.spacingRemoveTop}>
                                <FormLabel className={`${styles.labelText} displayFlex`} id="demo-row-radio-buttons-group-label">
                                    <div>1.&nbsp;</div>
                                    <div>{t("PreAuthForm.isPatientNPWTWound").replace('#patient', LineOfBusinessEnum.patientToMember.toLowerCase())}
                                        <span className={styles.asterisk}>&nbsp;*</span></div>
                                </FormLabel>
                                <RadioGroup
                                    className='paddingLeftFifteenpx'
                                    value={preAuthFormData[0].IsPatientNPWTWound}
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                >
                                    <FormControlLabel value="true" control={<Radio />} label="Yes" disabled={true} sx={{ cursor: 'not-allowed' }} />
                                    <FormControlLabel value="false" control={<Radio />} label="No" disabled={true} sx={{ cursor: 'not-allowed' }} />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    </Grid>}

                    {preAuthFormData[0]?.VendorName && <Grid container sx={{ paddingLeft: '20px' }}>
                        <Grid xs={12} className={styles.spacingTop}>
                            <Typography className={styles.labelText}>
                                a. {t("PreAuthForm.vendorName")}<span className={styles.asterisk}>&nbsp;*</span>
                            </Typography>
                            <TextField
                                aria-label="VendorName text field"
                                value={preAuthFormData[0].VendorName}
                                fullWidth
                                minRows={2}
                                maxLength={200}
                                size="small"
                                sx={{
                                    marginTop: '5px', borderRadius: "8px", backgroundColor: 'var(--color-disableField)', '& .Mui-disabled': {
                                        '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important',
                                    },
                                }}
                                disabled={true}
                                inputProps={{ style: { cursor: 'not-allowed' } }}
                            />
                        </Grid>
                    </Grid>}

                    {preAuthFormData[0]?.VendorPhone && <Grid container sx={{ paddingLeft: '20px' }}>
                        <Grid xs={12} className={styles.spacingTop}>
                            <Typography className={styles.labelText}>
                                b. {t("PreAuthForm.vendorPhone")}<span className={styles.asterisk}>&nbsp;*</span>
                            </Typography>
                            <TextField
                                aria-label="VendorPhone text field"
                                value={preAuthFormData[0].VendorPhone}
                                fullWidth
                                minRows={2}
                                maxLength={200}
                                size="small"
                                sx={{
                                    marginTop: '5px', borderRadius: "8px", backgroundColor: 'var(--color-disableField)', '& .Mui-disabled': {
                                        '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important',
                                    },
                                }}
                                disabled={true}
                                inputProps={{ style: { cursor: 'not-allowed' } }}
                            />
                        </Grid>
                    </Grid>}

                    {preAuthFormData[0]?.EstimatedLengthNPWTWound && <Grid container>
                        <Grid xs={12} className={styles.spacingTop}>
                            <Typography className={`${styles.labelText} displayFlex`}>
                                <div>2.&nbsp;</div>
                                <div>{t("PreAuthForm.estimatedLengthNPWTWound")}<span className={styles.asterisk}>&nbsp;*</span></div>
                            </Typography>
                            <TextField
                                aria-label="EstimatedLengthNPWTWound text field"
                                value={preAuthFormData[0].EstimatedLengthNPWTWound}
                                fullWidth
                                minRows={2}
                                maxLength={200}
                                size="small"
                                sx={{
                                    marginTop: '5px', borderRadius: "8px", backgroundColor: 'var(--color-disableField)', '& .Mui-disabled': {
                                        '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important',
                                    },
                                }}
                                disabled={true}
                                inputProps={{ style: { cursor: 'not-allowed' } }}
                            />
                        </Grid>
                    </Grid>}

                    {preAuthFormData[0]?.IsPhysicianOrder !== "" && preAuthFormData[0]?.IsPhysicianOrder !== undefined && <Grid container>
                        <Grid xs={12} className={styles.spacingTop}>
                            <FormControl className={styles.spacingRemoveTop}>
                                <FormLabel className={`${styles.labelText} displayFlex`} id="demo-row-radio-buttons-group-label">
                                    <div>3.&nbsp;</div>
                                    <div>{t("PreAuthForm.physicianOrder")}<span className={styles.asterisk}>&nbsp;*</span></div>
                                </FormLabel>
                                <Box component="span" sx={{ fontWeight: 'bold', fontStyle: "italic", marginLeft: '18px', marginTop:'4px' }}>{t('PreAuthForm.mdOrder')}</Box>
                                <RadioGroup
                                    className='paddingLeftFifteenpx'
                                    value={preAuthFormData[0].IsPhysicianOrder}
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                >
                                    <FormControlLabel value="true" control={<Radio />} label="Yes" disabled={true} sx={{ cursor: 'not-allowed' }} />
                                    <FormControlLabel value="false" control={<Radio />} label="No" disabled={true} sx={{ cursor: 'not-allowed' }} />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    </Grid>}

                    {preAuthFormData[0]?.ClinicalRationale && <Grid container>
                        <Grid xs={12} className={styles.spacingTop}>
                            <Typography className={`${styles.labelText} displayFlex`}>
                                <div>4.&nbsp;</div>
                                <div>{t("PreAuthForm.clinicalRationale")}<span className={styles.asterisk}>&nbsp;*</span></div>
                            </Typography>
                            <TextField
                                aria-label="ClinicalRationale text field"
                                value={preAuthFormData[0].ClinicalRationale}
                                fullWidth
                                minRows={3}
                                maxLength={500}
                                size="small"
                                sx={{
                                    marginTop: '5px', borderRadius: "8px", backgroundColor: 'var(--color-disableField)', '& .Mui-disabled': {
                                        '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important',
                                    },
                                }}
                                disabled={true}
                                inputProps={{ style: { cursor: 'not-allowed' } }}
                            />
                        </Grid>
                    </Grid>}

                    {preAuthFormData[0]?.IsFacilityRequested !== "" && preAuthFormData[0]?.IsFacilityRequested !== undefined && <Grid container>
                        <Grid xs={12} className={styles.spacingTop}>
                            <FormControl className={styles.spacingRemoveTop}>
                                <FormLabel className={styles.labelText} id="demo-row-radio-buttons-group-label">
                                    5. {t('PreAuthForm.facilityRequested')} <span className={styles.asterisk}>*</span>
                                </FormLabel>
                                <RadioGroup
                                    className='paddingLeftFifteenpx'
                                    value={preAuthFormData[0].IsFacilityRequested}
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                >
                                    <FormControlLabel value="true" control={<Radio />} label="Yes" disabled={true} sx={{ cursor: 'not-allowed' }} />
                                    <FormControlLabel value="false" control={<Radio />} label="No" disabled={true} sx={{ cursor: 'not-allowed' }} />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    </Grid>}

                    {preAuthFormData[0]?.FacilityRequestingName && <Grid container sx={{ paddingLeft: '20px' }}>
                        <Grid xs={12} className={styles.spacingTop}>
                            <Typography className={styles.labelText}>
                                {t('PreAuthForm.nameOfFacility')}<span className="asteriskSignColor"> *</span>
                            </Typography>
                            <TextField
                                aria-label="FacilityRequestingName text field"
                                value={preAuthFormData[0].FacilityRequestingName}
                                fullWidth
                                minRows={2}
                                maxLength={200}
                                size="small"
                                sx={{
                                    marginTop: '5px', borderRadius: "8px", backgroundColor: 'var(--color-disableField)', '& .Mui-disabled': {
                                        '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important',
                                    },
                                }}
                                disabled={true}
                                inputProps={{ style: { cursor: 'not-allowed' } }}
                            />
                        </Grid>
                    </Grid>}

                    <p className={styles.headingText} style={{marginBottom: '0px'}}>{t("PreAuthForm.woundDetails")}</p>

                    {preAuthFormData[0]?.DescriptionLocation && <Grid container>
                        <Grid xs={12} className={styles.spacingTop}>
                            <Typography className={styles.labelText}>
                                1. {t("PreAuthForm.location")} <span className={styles.asterisk}>*</span>
                            </Typography>
                            <TextField
                                aria-label="drainage text field"
                                value={preAuthFormData[0].DescriptionLocation}
                                fullWidth
                                minRows={2}
                                maxLength={200}
                                size="small"
                                sx={{
                                    marginTop: '5px', borderRadius: "8px", backgroundColor: 'var(--color-disableField)', '& .Mui-disabled': {
                                        '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important',
                                    },
                                }}
                                disabled={true}
                                inputProps={{ style: { cursor: 'not-allowed' } }}
                            />
                        </Grid>
                    </Grid>}

                    {preAuthFormData[0]?.DescriptionSize && <Grid container>
                        <Grid xs={12} className={styles.spacingTop}>
                            <Typography className={styles.labelText}>
                                2. {t("PreAuthForm.size")}<span className={styles.asterisk}>&nbsp;*</span>
                            </Typography>
                            <TextField
                                aria-label="DescriptionSize text field"
                                value={preAuthFormData[0].DescriptionSize}
                                fullWidth
                                minRows={2}
                                maxLength={200}
                                size="small"
                                sx={{
                                    marginTop: '5px', borderRadius: "8px", backgroundColor: 'var(--color-disableField)', '& .Mui-disabled': {
                                        '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important',
                                    },
                                }}
                                disabled={true}
                                inputProps={{ style: { cursor: 'not-allowed' } }}
                            />
                        </Grid>
                    </Grid>}

                    {preAuthFormData[0]?.DescriptionDepth && <Grid container>
                        <Grid xs={12} className={styles.spacingTop}>
                            <Typography className={styles.labelText}>
                                3. {t("PreAuthForm.depth")} <span className={styles.asterisk}>*</span>
                            </Typography>
                            <TextField
                                aria-label="DescriptionDepth text field"
                                value={preAuthFormData[0].DescriptionDepth}
                                fullWidth
                                minRows={2}
                                maxLength={200}
                                size="small"
                                sx={{
                                    marginTop: '5px', borderRadius: "8px", backgroundColor: 'var(--color-disableField)', '& .Mui-disabled': {
                                        '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important',
                                    },
                                }}
                                disabled={true}
                                inputProps={{ style: { cursor: 'not-allowed' } }}
                            />
                        </Grid>
                    </Grid>}

                    {preAuthFormData[0]?.DescriptionWidth && <Grid container>
                        <Grid xs={12} className={styles.spacingTop}>
                            <Typography className={styles.labelText}>
                                4. {t("PreAuthForm.width")} <span className={styles.asterisk}>*</span>
                            </Typography>
                            <TextField
                                aria-label="DescriptionWidth text field"
                                value={preAuthFormData[0].DescriptionWidth}
                                fullWidth
                                minRows={2}
                                maxLength={200}
                                size="small"
                                sx={{
                                    marginTop: '5px', borderRadius: "8px", backgroundColor: 'var(--color-disableField)', '& .Mui-disabled': {
                                        '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important',
                                    },
                                }}
                                disabled={true}
                                inputProps={{ style: { cursor: 'not-allowed' } }}
                            />
                        </Grid>
                    </Grid>}

                    {preAuthFormData[0]?.DescriptionDrainage && <Grid container>
                        <Grid xs={12} className={styles.spacingTop}>
                            <Typography className={styles.labelText}>
                                5. {t("PreAuthForm.drainage")} <span className={styles.asterisk}>*</span>
                            </Typography>
                            <TextField
                                aria-label="drainage text field"
                                value={preAuthFormData[0].DescriptionDrainage}
                                fullWidth
                                minRows={2}
                                maxLength={200}
                                size="small"
                                sx={{
                                    marginTop: '5px', borderRadius: "8px", backgroundColor: 'var(--color-disableField)', '& .Mui-disabled': {
                                        '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important',
                                    },
                                }}
                                disabled={true}
                                inputProps={{ style: { cursor: 'not-allowed' } }}
                            />
                        </Grid>
                    </Grid>}

                    {preAuthFormData[0]?.ClinicianName && <Grid container>
                        <Grid xs={12} className={styles.spacingTop}>
                            <Typography className={styles.labelText}>
                                {t('PreAuthForm.clinicalName')}  <span className={styles.asterisk}>*</span>
                            </Typography>
                            <TextField
                                aria-label="clinic text field"
                                value={preAuthFormData[0].ClinicianName}
                                fullWidth
                                minRows={2}
                                maxLength={200}
                                size="small"
                                sx={{
                                    marginTop: '5px', borderRadius: "8px", backgroundColor: 'var(--color-disableField)', '& .Mui-disabled': {
                                        '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important',
                                    },
                                }}
                                disabled={true}
                                inputProps={{ style: { cursor: 'not-allowed' } }}
                            />
                        </Grid>
                    </Grid>}

                    {preAuthFormData[0]?.AdministratorOrED && <Grid container>
                        <Grid xs={12} className={styles.spacingTop}>
                            <Typography className={styles.labelText}>
                                {t("PreAuthForm.edAdmin")} <span className={styles.asterisk}>*</span>
                            </Typography>
                            <TextField
                                fullWidth
                                maxLength={200}
                                aria-label="Admin field"
                                minRows={2}
                                value={preAuthFormData[0].AdministratorOrED}
                                size="small"
                                sx={{
                                    marginTop: '5px', borderRadius: "8px", backgroundColor: 'var(--color-disableField)', '& .Mui-disabled': {
                                        '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important',
                                    },
                                }}
                                disabled={true}
                                inputProps={{ style: { cursor: 'not-allowed' } }}
                            />
                        </Grid>
                    </Grid>}

                    {preAuthFormData[0]?.AVPO && <Grid container>
                        <Grid xs={12} className={styles.spacingTop}>
                            <Typography className={styles.labelText}>
                                {t("PreAuthForm.avpo")} <span className={styles.asterisk}>*</span>
                            </Typography>
                            <TextField
                                fullWidth
                                aria-label="avpo field"
                                minRows={2}
                                value={preAuthFormData[0].AVPO}
                                size="small"
                                maxLength={200}
                                sx={{
                                    marginTop: '5px', borderRadius: "8px", backgroundColor: 'var(--color-disableField)', '& .Mui-disabled': {
                                        '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.66) !important',
                                    },
                                }}
                                disabled={true}
                                inputProps={{ style: { cursor: 'not-allowed' } }}
                            />
                        </Grid>
                    </Grid>}
                </DialogContent>
                <DialogActions style={{ justifyContent: "end", padding: "14px 16px" }}>
                    <Button
                        onClick={handleClose}
                        color='secondary'
                    >
                        {t('NewOrder.close')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    )
}

NegativePressureWoundTherapy.formName = "NegativePressureWoundTherapy";
export default NegativePressureWoundTherapy;